import { useApiMutation } from "@/api";
import { resendInvite } from "@/entities/User";
import { Onboarding } from "@/features/Onboarding";
import { Illustration, Spinner } from "@/ui";
import { useSession } from "@/entities/Session";
import { Navigate } from "react-router-dom";
import { useEffect } from "react";
import { useAtom } from "jotai/react";
import { emailSentAtom } from "@/utils/misc/atoms";
export default function CompleteInvitationPage() {
    const [emailSent, setEmailSent] = useAtom(emailSentAtom);
    const { mutate: resendInvitationMail, isPending } =
        useApiMutation(resendInvite);
    const session = useSession();
    const email = session.user?.email;

    useEffect(() => {
        if (!emailSent) {
            resendInvitationMail();
            setEmailSent(true);
        }
    }, [emailSent]);

    if (!session.user) return <Navigate to="/login" />;

    return (
        <Onboarding.Layout centered>
            <div className="flex max-w-xl flex-col gap-10">
                <Illustration.VerifyEmail className="mx-auto mt-0 size-48" />
                <h2 className="text-center">Activate your account</h2>
                <p className="subdued text-center">
                    We’ve sent an activation email to {email}. Click the link
                    inside to continue.
                </p>
                <button
                    className="xl w-full"
                    onClick={() => resendInvitationMail()}
                    disabled={isPending}
                >
                    {isPending ? "Sending" : "Resend Email"}
                    {isPending && <Spinner />}
                </button>
            </div>
        </Onboarding.Layout>
    );
}
